import { CloseReason } from '~/services/base-ws/BaseWs';
import {
  PriceWS,
  TickerPayload,
  UpdateHandler,
} from '~/services/price-ws/PriceWS';
import { create } from '~/utils/store/createStore';

type WsInitConfig = {
  updateHandler: UpdateHandler;
  isPro: boolean;
};

interface SubscribeData {
  tickers: TickerPayload[];
  updateHandler: UpdateHandler;
  isPro: boolean;
}

interface LivePriceWebSocketStore {
  initialize: (config: WsInitConfig) => PriceWS;
  getPriceWS: (config: WsInitConfig) => PriceWS;
  subscribe: (data: SubscribeData) => void;
  unsubscribe: (tickers: TickerPayload[]) => void;
  closeConnection: () => void;
  priceWS: PriceWS | null;
}

export const livePriceWebSocket = create<LivePriceWebSocketStore>(
  (set, get) => ({
    priceWS: null,
    initialize: ({ updateHandler, isPro }) => {
      const priceWS = new PriceWS({ updateHandler, isPro });
      set({ priceWS });

      return priceWS;
    },

    getPriceWS: ({ updateHandler, isPro }) => {
      const { priceWS, initialize } = get();
      const isWebSocketClosed = !priceWS || priceWS.closed;

      return isWebSocketClosed ? initialize({ updateHandler, isPro }) : priceWS;
    },

    subscribe: ({ tickers, updateHandler, isPro }) => {
      const { getPriceWS } = get();
      const priceWS = getPriceWS({ updateHandler, isPro });

      priceWS.subscribe(tickers);
    },

    unsubscribe: (tickers: TickerPayload[]) => {
      const { priceWS } = get();

      priceWS?.unsubscribe(tickers);
    },

    closeConnection: () => {
      const { priceWS } = get();

      priceWS?.close(CloseReason.NoConnectionRequired);
    },
  })
);
